import React, { useRef } from "react";
import { Alert } from '@curves/ui-base';
import { useHistory } from "react-router-dom";
import { PageLayout } from "@Local/Components/Layout";
import { OverviewListLayout } from "@Local/Components/OverviewList";
import { getCyclePurchaseCancelOverviewRowLabel } from "@Root/Scripts/CyclePurchase/Cancel/CyclePurchaseCancelOverviewTemplate";
import { CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL } from "@Router/routerPath";
import useOverview from "@Util/hook/useOverview";
import useOrderCyclePurchaseApi from "@Apis/useOrderCyclePurchaseApi";
import { MemberOrderDetailsDialogBox } from "@Local/CyclePurchase/Overview/Dialog";
import CyclePurchaseCancelDialogBox from "./Detail/Dialog/CyclePurchaseCancelDialogBox";
const CyclePurchaseCancelOverviewPage = () => {
	const { getOrdersCyclePurchasePaymentErrorsApi } = useOrderCyclePurchaseApi();
	const history = useHistory();
	const currentSearch = history.location?.search || ""; // 目前搜尋條件
	// 導向循環訂單明細頁，並保留當前搜尋條件
	const pushToCyclePurchaseDetail = cycleOrderID => {
		history.push({
			pathname: CYCLE_PURCHASE_DETAIL_MAIN_ROUTER_URL(cycleOrderID),
			search: currentSearch,
		});
	};
	const { overviewData, getOverviewData } = useOverview({
		getOverviewApi: getOrdersCyclePurchasePaymentErrorsApi,
		isFetchOnMount: true,
		enableQueryString: false,
	});
	const dialogRef = useRef(null);
	const cancelDialogRef = useRef(null);
	const refreshRef = useRef(getOverviewData);
	const headerRow = getCyclePurchaseCancelOverviewRowLabel(pushToCyclePurchaseDetail, overviewData, dialogRef, getOverviewData, cancelDialogRef);
	return (
		<PageLayout>
			<PageLayout.Header title="循環訂單退訂總覽" />
			<OverviewListLayout
				contextValue={{
					refresh: refreshRef.current,
					setRefresh: fn => (refreshRef.current = fn),
				}}
			>
				<Alert color="info" severity="info" variant="outlined" className="my-2">
					以下列示過卡失敗次數已達三次之循環訂單。請於主單明細頁確認後執行退訂作業，退訂完成後該筆訂單將自列表移除。
				</Alert>
				<OverviewListLayout.Table
					headerRow={headerRow}
					list={overviewData?.list || []}
					tableRowBodyProps={{ dialogRef: null }}
				/>
			</OverviewListLayout>
			<MemberOrderDetailsDialogBox ref={dialogRef} />
			<CyclePurchaseCancelDialogBox ref={cancelDialogRef} />
		</PageLayout>
	);
};
export default CyclePurchaseCancelOverviewPage;
